module.exports = __webpack_public_path__ + "img/folder-dark-yellow.c645c898.svg";